<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.banner.form.type')" prop="type" >
        <a-select
          v-model="form.type"
          :disabled="typeSelectDisabled"
          :placeholder="$t('views.banner.form.typePlaceholder')"
          :allow-clear="!typeSelectDisabled"
        >
          <a-select-option :value="0">{{ $t('views.banner.type.home') }}</a-select-option>
          <a-select-option :value="1" :disabled="companyTypeOptionDisabled">{{ $t('views.banner.type.company') }}</a-select-option>
        </a-select>
        <div v-if="companyTypeOptionDisabled && formType === 1" class="banner-type-tip">
          {{ $t('views.banner.msg.companyTypeExists') }}
        </div>
      </a-form-model-item>
      <a-form-model-item v-if="form.type == 1" :label="$t('views.banner.form.title')" prop="title" >
        <a-input v-model="form.title" :maxLength="255" :placeholder="$t('views.banner.form.titlePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item v-if="form.type == 1" :label="$t('views.banner.form.titleEn')" prop="titleEn" >
        <a-input v-model="form.titleEn" :placeholder="$t('views.banner.form.titleEnPlaceholder')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('views.banner.form.remark')" prop="remark" v-if="form.type == 1">
        <a-input v-model="form.remark" :placeholder="$t('views.banner.form.remarkPlaceholder')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.banner.form.remarkEn')" prop="remarkEn" v-if="form.type == 1">
        <a-input v-model="form.remarkEn" :placeholder="$t('views.banner.form.remarkEnPlaceholder')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item v-if="form.type == 1" :label="$t('views.banner.form.content')" prop="content" >
        <editor :key="'banner-content-' + (form.id || 'new')" v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item v-if="form.type == 1" :label="$t('views.banner.form.contentEn')" prop="contentEn" >
        <editor :key="'banner-contentEn-' + (form.id || 'new')" v-model="form.contentEn" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.banner.form.linkType')" prop="linkType" v-if="form.type == 0">
        <a-select v-model="form.linkType" :placeholder="$t('views.banner.form.linkTypePlaceholder')" allow-clear>
          <a-select-option :value="0">{{ $t('views.banner.form.linkTypeNone') }}</a-select-option>
          <a-select-option :value="3">{{ $t('views.banner.form.linkTypeOuter') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.banner.form.linkUrl')" v-if="form.type == 0" prop="linkUrl" >
        <a-input v-model="form.linkUrl" :maxLength="255" :placeholder="$t('views.banner.form.linkUrlPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.banner.form.image')" prop="imgUrl" >
        <file-upload v-model="form.imgUrl" type="image" @change="changeSwiper"></file-upload>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.banner.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.banner.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBanner, addBanner, updateBanner, pageBanner } from '@/api/banner/banner'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formType: 1,
      /** 是否已存在类型=公司简介(1) 的轮播 */
      companyTypeExists: false,
      /** 已存在的公司简介轮播 id（编辑本条时不拦截） */
      existingCompanyBannerId: null,
      open: false,
      form: {
        id: null,
        type: 0,
        title: null,
        titleEn: null,
        content: null,
        contentEn: null,
        link: null,
        linkUrl: null,
        imgUrl: null,
        linkType: null,
        isVisible: 1,
        sort: 0,
        createTime: null,
        remark: null,
        remarkEn: null
      }
    }
  },
  computed: {
    formTitle () {
      return this.formType === 1
        ? this.$t('views.banner.title.add')
        : this.$t('views.banner.title.edit')
    },
    /** 编辑且当前为公司简介(1) 时，类型下拉整体禁用 */
    typeSelectDisabled () {
      return this.formType === 2 && Number(this.form.type) === 1
    },
    /** 新增时若已有公司简介则禁用 type=1；编辑首页记录时不可改选公司简介 */
    companyTypeOptionDisabled () {
      if (!this.companyTypeExists) {
        return false
      }
      if (this.formType === 1) {
        return true
      }
      return Number(this.form.type) !== 1
    },
    rules () {
      return {
        imgUrl: [
          { required: true, message: this.$t('views.banner.rule.imgRequired'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: this.$t('views.banner.rule.sortRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /** 新增重复选公司简介，或编辑时改为公司简介但已存在其它公司简介记录 */
    isCompanyTypeSubmitBlocked () {
      if (!this.companyTypeExists) {
        return false
      }
      if (this.formType === 1) {
        return true
      }
      if (this.existingCompanyBannerId == null || this.form.id == null) {
        return true
      }
      return String(this.existingCompanyBannerId) !== String(this.form.id)
    },
    changeSwiper (e) {
      this.form.imgUrl = e
    },
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    loadCompanyBannerExists () {
      return pageBanner({ type: 1, pageNum: 1, pageSize: 10 }).then(response => {
        const data = (response && response.data) || {}
        const total = data.total != null ? Number(data.total) : 0
        const records = data.records || []
        this.companyTypeExists = total > 0 || records.length > 0
        this.existingCompanyBannerId = records.length > 0 ? records[0].id : null
      }).catch(() => {
        this.companyTypeExists = false
        this.existingCompanyBannerId = null
      })
    },
    reset () {
      this.formType = 1
      this.companyTypeExists = false
      this.existingCompanyBannerId = null
      this.form = {
        id: null,
        type: 0,
        title: null,
        titleEn: null,
        content: null,
        contentEn: null,
        link: null,
        linkUrl: null,
        imgUrl: null,
        linkType: null,
        isVisible: 1,
        sort: 0,
        createTime: null,
        remark: null
      }
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.loadCompanyBannerExists().then(() => {
        if (this.companyTypeExists && Number(this.form.type) === 1) {
          this.form.type = 0
        }
      })
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      this.loadCompanyBannerExists()
      getBanner({ id }).then(response => {
        const d = response.data || {}
        const merged = { ...this.form, ...d }
        if (merged.type != null) {
          merged.type = Number(merged.type)
        }
        if (merged.linkType != null) {
          merged.linkType = Number(merged.linkType)
        }
        if (merged.title == null) merged.title = ''
        if (merged.titleEn == null) merged.titleEn = ''
        if (merged.content == null) merged.content = ''
        if (merged.contentEn == null) merged.contentEn = ''
        if (merged.remark == null) merged.remark = ''
        if (merged.remarkEn == null) merged.remarkEn = ''
        this.form = merged
        this.open = true
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (Number(this.form.type) === 1 && this.companyTypeExists && this.isCompanyTypeSubmitBlocked()) {
            this.$message.warning(this.$t('views.banner.msg.companyTypeExists'))
            return false
          }
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBanner(this.form).then(response => {
              if (response.success) {
                this.$message.success(
                  this.$t('views.banner.msg.updateOk'),
                  3
                )
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBanner(this.form).then(response => {
              if (response.success) {
                this.$message.success(
                  this.$t('views.banner.msg.addOk'),
                  3
                )
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.banner-type-tip {
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  line-height: 1.5;
}
</style>
